module.exports = __webpack_public_path__ + "img/di12.b55b7ae6.png";